import { Link } from "react-router-dom";
import { Heart, Mail, MapPin, Phone, Linkedin } from "lucide-react";

const LOGO_URL = "/logo.png";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-slate-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="h-11 w-11 rounded-xl bg-slate-800/80 ring-1 ring-blue-500/30 p-0.5 flex items-center justify-center overflow-hidden">
                <img src={LOGO_URL} alt="EDUCPEOPLE" className="h-full w-full object-contain" style={{ filter: 'brightness(1.8) saturate(1.4)' }} />
              </div>
              <span className="font-heading text-xl font-semibold text-slate-50">EDUCPEOPLE</span>
            </Link>
            <p className="font-body text-sm text-slate-400 leading-relaxed mb-4">
              L'education pour tous, augmentee par l'innovation.
            </p>
            <p className="font-body text-xs text-slate-500">
              Association loi 1901 - SIREN 839 800 851
            </p>
          </div>

          <div>
            <h4 className="font-heading text-lg font-medium text-slate-50 mb-6">Navigation</h4>
            <ul className="space-y-3">
              {[
                { label: "Accueil", path: "/" },
                { label: "Notre Mission", path: "/mission" },
                { label: "Programmes", path: "/programmes" },
                { label: "Projets", path: "/projets" },
                { label: "Blog", path: "/blog" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="font-body text-sm text-slate-400 hover:text-blue-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-lg font-medium text-slate-50 mb-6">S'engager</h4>
            <ul className="space-y-3">
              {[
                { label: "Faire un don", path: "/soutenir" },
                { label: "Devenir partenaire", path: "/partenaires" },
                { label: "Nous contacter", path: "/contact" },
              ].map((item) => (
                <li key={item.path}>
                  <Link to={item.path} className="font-body text-sm text-slate-400 hover:text-blue-400 transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
            <a
              href="https://www.linkedin.com/company/educpeople/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-linkedin"
              className="inline-flex items-center gap-2 mt-6 bg-[#0A66C2] hover:bg-[#004182] text-white px-5 py-2.5 rounded-full font-body text-sm font-medium transition-all duration-300"
            >
              <Linkedin className="w-4 h-4" />
              Suivez-nous
            </a>
          </div>

          <div>
            <h4 className="font-heading text-lg font-medium text-slate-50 mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-blue-400 mt-0.5 shrink-0" />
                <span className="font-body text-sm text-slate-400">
                  40 Rue du Pave des Gardes<br />92370 Chaville
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-blue-400 shrink-0" />
                <a href="mailto:contact@educpeople.org" className="font-body text-sm text-slate-400 hover:text-blue-400 transition-colors">
                  contact@educpeople.org
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-blue-400 shrink-0" />
                <span className="font-body text-sm text-slate-400">+33 9 72 38 65 14</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="section-divider mb-8" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-slate-500">
            &copy; {new Date().getFullYear()} EDUCPEOPLE.org - Tous droits reserves
          </p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="font-body text-xs text-slate-500 hover:text-blue-400 transition-colors">Mentions l{"\u00e9"}gales</Link>
            <Link to="/confidentialite" className="font-body text-xs text-slate-500 hover:text-blue-400 transition-colors">Confidentialit{"\u00e9"}</Link>
          </div>
          <div className="flex items-center gap-2 font-body text-xs text-slate-500">
            <span>Fait avec</span>
            <Heart className="w-3 h-3 text-blue-400" />
            <span>pour l'education inclusive</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
